module.exports = __webpack_public_path__ + "img/ztcbg.68956c8d.png";